var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-wrapper"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"mb-lg"},[_vm._v("Oops!")]),_c('p',[_vm._v("Something went terribly wrong.")]),_c('p',[_vm._v("We have unleashed our code monkeys to fix it. Please try again later.")])])])
}]

export { render, staticRenderFns }